/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector } from 'react-redux';
// component
import NewStatus from './newstatus/newstatus';
// styles
import injectSheet from 'react-jss';
import styles from './navsubitem_styles';
import { useNavigation } from 'utils/navigation';

/* ========== ~~~~~~~~~~ NAV SUB ITEM ~~~~~~~~~~ ========== */
const NavSubItem = injectSheet(styles)((props) => {
	const {handleRouteClick} = props;
	const currentPage = useSelector(state => state.app.currentPage);
	const { handleNavigation } = useNavigation()

	const handleActiveState = () => currentPage && currentPage.includes(props.route);

	const handleRoute = () => {
		if(handleRouteClick) {
			handleRouteClick();
			return;
		}
		if(props.externalLink) {
			window.open(props.externalLink, '_blank')
			return
		}
		if(!props.route && props.handleOnClick) {
			props.handleOnClick()
		} else {
			handleNavigation(props.route)
		}
	};
	
	return (
		<div className={`navsubitem ${props.classes.navsubitem} isActive-${handleActiveState()} isDisabled-${props.disabled}`} onClick={handleRoute}>
			<div className={`indicator`}><div className={`dot`} /></div>
			<div className={`text`}>{props.text}</div>
			{props.isNew && <NewStatus />}
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default NavSubItem;
